<template>
  <div style="background-color: #f9f9f9">
    <section id="detail-produk-lending" class="container">
      <CardDetailProduk :itemLendings="itemLendings" :location="location" />
      <div class="row">
        <div class="col-md-4 mb-4">
          <section class="border p-4 h-auto bg-white" style="border-radius: 12px;">
            <div>
              <h5 class="product-sub-title text-center">
                Simulasi Pembiayaan Kendaraan
              </h5>
              <h5 class="product-sub-title text-center text-uppercase">
                {{this.itemLendings.mitra.mitra_profile.nama_organisasi_perusahaan}}
              </h5>
            </div>

            <div
              class="mb-3 mx-auto"
              style="width: 300px; height: 300px; display: flex; justify-content: center; align-items: center; overflow: hidden;"
            >
              <img
                :src="getImageUrl(this.itemLendings.mitra.mitra_profile.logo_mitra)"
                alt="Logo BPRS"
                style="width: 100%; height: 100%; object-fit: contain;"
              />
            </div>

            <div class="form-group">
              <label class="product-sub-title">Total Uang Muka</label>
              <b-form-input
                type="text"
                class="form-control"
                v-model="formattedHarga"
                :value="formatRupiah(simulation.downPayment)"
                @input="onInputDownPayment"
                @keypress="onlyNumberKey"
                inputmode="numeric"
                placeholder="Masukkan Total Uang Muka"
              ></b-form-input>
              <small v-if="parseInt(form.price) < this.itemLendings.down_payment" class="text-danger">
                Total Uang muka minimal {{ formatRupiah(this.itemLendings.down_payment) }}
              </small>
            </div>

            <div class="form-group">
              <label class="product-sub-title">Tenor Pembiayaan</label>
              <select class="form-control" v-model="simulation.tenor">
                <option disabled value="">Pilih Jangka Waktu</option>
                <option
                  v-for="(option, index) in tenorOptions"
                  :key="index"
                  :value="option[0]"
                >
                  {{ option[0] }} Bulan
                </option>
              </select>
              <p v-if="selectedTenorTotal !== null" class="mt-2 text-danger">
                Premi Asuransi : {{ formatRupiah(selectedTenorTotal) }}
              </p>
            </div>

            <div class="form-group">
              <label class="product-sub-title">Margin Pembiayaan</label>
              <input
                type="text"
                class="form-control"
                :value="totalMarginComputed"
                disabled
              />
            </div>

            <div class="form-group">
              <label class="product-sub-title">Biaya Administrasi</label>
              <input
                type="text"
                class="form-control"
                :value="this.itemLendings.is_nominal
                  ? formatRupiah(this.itemLendings.administration_fee)
                  : `${this.itemLendings.administration_fee} %`"
                disabled
              />
            </div>

            <div class="form-group">
              <label class="product-sub-title">Biaya Lainnya</label>
              <input
                type="text"
                class="form-control"
                :value="this.itemLendings.other_fee_description + ' : ' + formatRupiah(this.itemLendings.other_fee_amount)"
                disabled
              />
            </div>

            <div class="form-group">
              <label class="product-sub-title">Lokasi</label>
              <select class="form-control" v-model="selectedLocation">
                <option disabled value="">Pilih Lokasi</option>
                <option
                  v-for="(kota, index) in location"
                  :key="index"
                  :value="kota.code"
                >
                  {{ kota.name }}
                </option>
              </select>
            </div>

            <div class="text-center my-5">
              <p
                class="font-weight-normal"
                style="color: #13346c; font-size: 20px"
              >
                Angsuran Per Bulan
              </p>
              <h4 class="rupiah-format font-weight-bold" style="font-size: 28px; font-weight: normal;">
                <span v-if="isLoadingSimulation">
                  <b-spinner label="Loading..."></b-spinner>
                </span>
                <span v-else>
                  {{ formatRupiah(simulation.monthlyInstallment[0].total_payment) }}
                </span>
              </h4>
            </div>

            <!-- Tombol Ajukan -->
            <div class="d-flex justify-content-center">
              <button class="button-primary m-auto" @click="showPengajuanModal = true">
                Ajukan Sekarang
              </button>
            </div>

            <!-- Modal Pengajuan -->
            <newCustomModal :visible="showPengajuanModal" @close="showPengajuanModal = false;">
              <div class="form-group">
                <label class="product-sub-title">Konfirmasi Nominal Uang Muka Anda</label>
                <br>
                <small class="text-warning">
                  *Total Uang Muka Minimal Adalah Sebesar {{ formatRupiah(this.itemLendings.down_payment) }}
                </small>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model="formattedHarga"
                  :value="formatRupiah(simulation.downPayment)"
                  @input="onInputDownPayment"
                  @keypress="onlyNumberKey"
                  inputmode="numeric"
                  placeholder="Masukkan Total Uang Muka"
                ></b-form-input>
              </div>

              <div class="form-group">
                <label class="product-sub-title">Konfirmasi Tenor Pembiayaan Anda</label>
                <br>
                <select class="form-control" v-model="simulation.tenor">
                  <option disabled value="">Pilih Jangka Waktu</option>
                  <option
                    v-for="(option, index) in tenorOptions"
                    :key="index"
                    :value="option[0]"
                  >
                    {{ option[0] }} Bulan
                  </option>
                </select>
                <p v-if="selectedTenorTotal !== null" class="mt-2 text-danger">
                  Premi Asuransi : {{ formatRupiah(selectedTenorTotal) }}
                </p>
              </div>

              <div class="form-group">
                <label class="product-sub-title">Konfirmasi Varian Warna Pilihan Anda</label>
                <select class="form-control" v-model="simulation.colorVariant">
                  <option disabled value="">Pilih Warna</option>
                  <option
                    v-for="(variant, index) in itemLendings.sub_brand.images"
                    :key="index"
                    :value="variant.id"
                  >
                    {{ variant.variant }}
                  </option>
                </select>
              </div>

              <small class="text-warning">
                *{{ this.itemLendings.mitra.mitra_profile.nama_organisasi_perusahaan }} akan mengutamakan variant warna yang Anda pilih. Customer Service {{ this.itemLendings.mitra.mitra_profile.nama_organisasi_perusahaan }} akan menghubungi Anda kembali dengan informasi terkini mengenai ketersediaan unit.
              </small>

              <!-- Saat tombol tidak loading -->
              <div class="d-flex justify-content-end mt-4" v-if="!isSubmitting">
                <button class="custom-btn danger" @click="showPengajuanModal = false;">
                  Batal
                </button>
                <button class="custom-btn primary" @click="handleAjukan">
                  Ajukan
                </button>
              </div>

              <!-- Saat loading, tampilkan spinner -->
              <div class="d-flex justify-content-center mt-4" v-else>
                <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                <!-- <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Mengirim...</span>
                </div> -->
              </div>
            </newCustomModal>
          </section>
        </div>

        <!-- Tabel Angsuran -->
        <div class="col-md-8 mb-4">
          <h5 class="product-sub-title">Tabel Angsuran Pembiayaan</h5>
          <p class="product-sub-title-thin my-0">
            {{ this.itemLendings.sub_brand.name + ' - ' + formatRupiah(this.itemLendings.price) + ' (OTR)' }}
          </p>
          <div class="table-wrapper-scroll">
            <table class="table table-bordered text-center custom-table-size">
              <thead class="custom-head">
                <tr>
                  <th>Bulan</th>
                  <th>Margin</th>
                  <th>Pokok</th>
                  <th>Total Angsuran</th>
                  <th>Sisa Pembiayaan</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in simulation.monthlyInstallment" :key="index">
                  <td class="table-data-text">{{ item.month }}</td>
                  <td class="table-data-text">{{ formatRupiah(item.interest_payment) }}</td>
                  <td class="table-data-text">{{ formatRupiah(item.principal_payment) }}</td>
                  <td class="table-data-text">{{ formatRupiah(item.total_payment) }}</td>
                  <td class="table-data-text">{{ formatRupiah(item.remaining_principal) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pilihan Warna -->
          <MotorColorSelector
            :colors="motor.colors"
            @color-selected="handleColorSelected"
          />
          <!-- Syarat dan Pengajuan -->
          <SyaratPengajuan />
        </div>
      </div>
      <CustomModal v-if="modalVisible" :action="modalAction" @close="modalVisible = false">
        <h4 v-if="modalAction === 'success'">Pengajuan Berhasil</h4>
        <h4 v-else>Pengajuan Gagal</h4>
        <p v-html="modalMessage"></p>
        <div class="modal-button-group">
          <button
            class="custom-btn danger"
            @click="modalVisible = false"
          >
            Tutup
          </button>
          <button
            class="custom-btn primary"
            v-if="modalAction === 'success'"
            @click="$router.push('/pengajuan-saya')"
          >
            Ke Dashboard
          </button>
        </div>
      </CustomModal>
    </section>
    <NewFooterClient />
  </div>
</template>

<script>
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import Cookies from 'js-cookie';
import ProductLending from "../api/produkLendingV3";
import Product from "../api/produk";
import newCustomModal from "../components/newCustomModal.vue";
import CustomModal from '../components/CustomModal.vue';
import PengajuanLending from "../api/PengajuanLending";
import MotorColorSelector from '@/components/MotorColorSelector.vue';
import SyaratPengajuan from '@/components/SyaratPengajuan.vue';
import CardDetailProduk from '@/components/CardDetailProduk.vue';

export default {
  data() {
    return {
      isSubmitting: false,
      selectedMotorColor: null,
      company: {
        logo: "https://via.placeholder.com/150x80?text=LOGO+BPR",
      },
      simulation: {
        downPayment: null,
        tenor: '',
        tenorOptions: [],
        monthlyInstallment: null,
        colorVariant: ''
      },
      selectedTenorTotal: null,
      selectedPercentage: null,
      isLoadingSimulation: false,
      product_id : '',
      loading: true,
      itemLendings: [],
      form:{
        price: ''
      },
      location: '',
      selectedLocation: '',
      isLoadingSimulation: false,
      showPengajuanModal: false,
      modalVisible: false,
      modalAction: "",
      modalMessage: "",
    };
  },
  mounted(){
    this.loadData();
  },    
  components: { 
    NewFooterClient,
    newCustomModal,
    CustomModal,
    MotorColorSelector,
    SyaratPengajuan,
    CardDetailProduk
  },
  computed:{
    totalMarginComputed() {
      const margin = this.itemLendings.margin_amount;
      return this.margiCounted(margin);
    },
    motor() {
      const images = this.itemLendings.sub_brand.images || [];
      return {
        image: images.length ? `${process.env.API_URL}${images[0].image}` : '',
        colors: images.map(img => ({
          label: img.variant,
          color: `${process.env.API_URL}${img.image}`
        }))
      };
    },
    formattedHarga: {
      get() {
        return this.formatRupiah(this.form.price);
      },
      set(value) {
        this.form.price = this.parseCurrency(value);
        this.simulation.downPayment = this.parseCurrency(value);
      },
    },
    tenorOptionsRaw() {
      try {
        return JSON.parse(this.itemLendings.tenure_period || '[]');
      } catch (e) {
        return [];
      }
    },
    tenorOptions() {
      return this.tenorOptionsRaw;
    },
  },
  watch: {
    'simulation.downPayment': 'handleSimulationChange',
    'simulation.tenor': 'handleSimulationChange',
    'simulation.tenor'(newTenorIndex0) {
      const selected = this.tenorOptions.find(opt => opt[0] === newTenorIndex0);
      if (selected) {
        const percentage = selected[1];
        const price = this.itemLendings.price || 0;
        this.selectedPercentage = percentage;
        this.selectedTenorTotal = (percentage / 100) * price;

        // Panggil handleSimulationChange setelah tenor valid
        this.handleSimulationChange();
      } else {
        this.selectedPercentage = null;
        this.selectedTenorTotal = null;
      }
    },
  },
  methods: {
    handleColorSelected(color) {
      this.selectedMotorColor = color;
    },
    async handleSimulationChange() {
      const tenorValue = this.simulation.tenor;

      if (this.product_id && this.simulation.downPayment && tenorValue) {
        this.isLoadingSimulation = true;

        try {
          const res = await Product.installmentSimulation(
            this.product_id,
            this.simulation.downPayment,
            tenorValue
          );
          this.simulation.monthlyInstallment = res.data.data;
        } catch (error) {
          console.error('Gagal ambil simulasi:', error);
          this.showToast("Terjadi kesalahan saat memuat data simulasi.", "Kesalahan", "danger");
        } finally {
          this.isLoadingSimulation = false;
        }
      }
    },
    handleAjukan() {
      if (!this.form.price || this.form.price < this.itemLendings.down_payment) {
        this.showToast("Total Uang muka harus diisi dan lebih dari 0", "Error", "danger");
        return;
      }

      if (!this.simulation.tenor) {
        this.showToast("Silakan pilih tenor pembiayaan", "Error", "danger");
        return;
      }

      if (!this.simulation.colorVariant || this.simulation.colorVariant.trim() === '') {
        this.showToast("Silakan masukkan warna pilihan Anda", "Error", "danger");
        return;
      }

      const payload = {
        product_id: this.product_id,
        variant_id: this.simulation.colorVariant,
        down_payment_amount: this.form.price,
        tenor: this.simulation.tenor[0],
        premi: this.simulation.tenor[1],
      };

      this.isSubmitting = true;

      PengajuanLending.store(payload)
        .then(res => {
          if (res.data.meta.code !== 200) {
            this.modalAction = "error";
            this.modalMessage = res.meta.messages + '<br>' + res.data.join('<br>');
          } else {
            this.modalAction = "success";
            this.modalMessage = "Pengajuan Anda berhasil dikirim. Silakan tunggu konfirmasi dari tim kami.";
            this.showPengajuanModal = false;
          }

          this.modalVisible = true;
        })
        .catch(() => {
          this.modalAction = "error";
          this.modalMessage = "Terjadi kesalahan saat mengirim pengajuan. Silakan coba lagi.";
          this.modalVisible = true;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    showToast(message, title, variant = "default") {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    loadData() {
      this.loading = true; 
      this.product_id = Cookies.get('product_id');
      if (!this.product_id) {
        this.$nextTick(() => {
          this.$router.push({ name: 'list_lending_detail' });
        });
        return;
      }
      try {
        const params = {
          search_sub_brand_id : this.sub_brand_id,
          with: 'subBrand.images,brand,mitra.mitra_profile' 
        };
        ProductLending.show(params,this.product_id)
          .then(async res => {
            this.itemLendings = res.data.data;
            // console.log("itemlendiing : ", this.itemLendings);
            this.form.price = this.itemLendings.down_payment;
            try {
              const kotaCodes = JSON.parse(this.itemLendings.city_coverage || '[]');
              const requests = kotaCodes.map(async (code) => {
                try {
                  const response = await fetch(`https://new-staging-api.efund.id/api/v1/addresses/kota/${code}`);
                  const data = await response.json();
                  return {
                    code: code,
                    name: data.nama || `Kode ${code}`
                  };
                } catch (error) {
                  return {
                    code: code,
                    name: `Gagal ambil kota (${code})`
                  };
                }
              });
              this.location = await Promise.all(requests);

              this.simulation.downPayment = this.itemLendings.down_payment;
              // this.simulation.tenor = this.itemLendings.tenure_period[0];
              const waktuArray = JSON.parse(this.itemLendings.tenure_period || '[]');
              this.simulation.tenor = waktuArray[0];
              const tenorValue = Array.isArray(this.simulation.tenor)
              ? this.simulation.tenor[0]
              : this.simulation.tenor;

              const res = await Product.installmentSimulation(
                this.product_id,
                this.simulation.downPayment,
                tenorValue
              );
              this.simulation.monthlyInstallment = res.data.data;
            } catch (err) {
              console.error('Gagal parse city_coverage:', err);
              this.location = [];
            }

            this.loading = false;
          })
          .catch(err => {
            console.log("error produk lending : ", err);
            this.loading = false;
          });
      } catch (err) {
        console.error('Catch block error:', err);
        this.loading = false;
      }
    }, 
    
    
    onInputDownPayment(event) {
      const raw = event.target.value.replace(/\D/g, '');
      const min = this.itemLendings.down_payment || 0;

      const parsed = parseInt(raw || '0');

      this.form.price = parsed < min ? min : parsed;
    },
    getImageUrl(item) {
      return item
        ? item
        : "";
    },
    formatRupiah(value) {
      if (!value) return "Rp 0";
      return "Rp " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onlyNumberKey(event) {
      const charCode = event.charCode ? event.charCode : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    parseCurrency(value) {
      return parseFloat(value.replace(/[^0-9,-]+/g, '').replace(',', '.')) || null;
    },
    margiCounted(margin) {
      const price = this.itemLendings.price || 0;
      const DP = this.form.price != null ? this.form.price : this.itemLendings.down_payment || 0;
      const hpp = price - DP;
      const tenor = parseInt(this.simulation.tenor) || 0; // dalam bulan

      const monthlyMarginRate = margin / 12 / 100; // margin tahunan dibagi 12 bulan dan jadi persentase
      const totalMargin = hpp * monthlyMarginRate * tenor;

      return this.formatRupiah(totalMargin);
    }
  },
};
</script>

<style scoped>
h2, h4 {
  letter-spacing: 0;
}

/* Tombol biru rounded */
.custom-btn {
  background-color: #007bff;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 30px; /* Atau 4px, pilih salah satu */
  font-weight: 600;
  cursor: pointer;
  min-width: 100px;
  text-align: center;
}

.custom-btn.primary {
  background-color: #004990; /* Biru */
  color: #fff;
  margin-left: 7px;
}

.custom-btn.danger {
  background-color: #dc3545; /* Merah */
  color: #fff;
}
.product-name {
  font-size: 40px;
  margin: 0;
  padding: 0;
  font-weight: 600;
  text-transform: capitalize;
  color: #13346c;
}
.rupiah-format {
  font-size: 48px;
  margin: 0;
  padding: 0;
  font-weight: 600;
  text-transform: capitalize;
  color: #13346c;
}
.container {
  max-width: 90%;
}
.text-installment {
  font-size: 20px;
  font-weight: 400;
  color: #13346c;
  text-align: center;
  margin: 0;
  padding: 0;
}
.product-sub-title {
  font-size: 20px;
  font-weight: 600;
  color: #13346c;
  text-transform: capitalize;
}
.product-sub-title-thin {
  color: #13346c;
}
.product-description {
  font-size: 16px;
  color: #b3b3b3;
  font-weight: 400;
}
.product-description-blue {
  font-size: 20px;
  color: #13346c;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
.installment-container {
  display: flex;
  flex-direction: column; /* Stack children vertically */
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally (optional) */
  height: 100%; /* Fill full height of td */
  width: 100%;
}
thead.custom-head {
  background-color: #13346c;
  color: #fff;
  font-weight: 500;
}
.table-data-text {
  font-size: 18px;
  color: #13346c;
  font-weight: 300;
}

.rounded-table-wrapper {
  border: 1px solid #dee2e6;
  border-radius: 12px;
  overflow: hidden;
}
.rounded-table-wrapper table {
  margin-bottom: 0;
}
.button-primary {
  padding: 15px 25px;
  background-color: #f7bd3a;
  color: white;
  font-weight: 600;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
}
.button-primary:hover {
  transform: scale(105%);
}
.button-secondary {
  padding: 15px 25px;
  background-color: #274c8e;
  color: white;
  font-weight: 600;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
}
.button-secondary:hover {
  transform: scale(105%);
}
@media (max-width: 768px) {
  .container {
    margin-top: 1rem;
    max-width: 90%;
  }
  .product-name {
    font-size: 32px;
    margin: 0;
    padding: 0;
    font-weight: 600;
    text-transform: capitalize;
  }
  .product-sub-title {
    font-size: 20px;
    font-weight: 600;
    color: #13346c;
    text-transform: capitalize;
  }
  .product-sub-title-thin {
    color: #13346c;
  }
  .product-description {
    font-size: 14px;
    color: #b3b3b3;
    font-weight: 400;
  }
  .product-description-blue {
    font-size: 14px;
    color: #13346c;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
  .text-installment {
    font-size: 12px;
    font-weight: 400;
    color: #13346c;
    text-align: center;
    margin: 0;
  }
  .installment-container {
    display: flex;
    flex-direction: column; /* Stack children vertically */
    justify-content: center; /* Center vertically */
    align-items: center; /* Center horizontally (optional) */
    height: 100%; /* Fill full height of td */
    width: 100%;
    background-color: black;
  }
}
.table-wrapper {
  border: 1px solid #dee2e6;
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
}

/* Gambar desktop */
.img-container {
  height: 250px;
  width: 100%;
  max-width: 300px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.img-product {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.mobile-img-wrapper {
  width: 100%;
  background-color: #fff;
  padding: 16px 0;
  display: flex;
  justify-content: center; /* ini yang paling penting */
  align-items: center;
}

.mobile-img {
  width: auto;
  max-width: 90%;
  height: auto;
  max-height: 250px;
  object-fit: contain;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .product-name {
    font-size: 1.2rem;
  }

  .product-sub-title {
    font-size: 0.9rem;
  }

  .product-description {
    font-size: 0.85rem;
  }

  .text-installment {
    font-size: 0.9rem;
    text-align: center;
  }

  /* Pastikan table responsive bisa scroll di mobile */
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Untuk scroll halus di iOS */
  width: 100%;
  margin-bottom: 1rem; /* agar ada jarak di bawah tabel */
}

.rounded-table-wrapper {
  border: 1px solid #dee2e6;
  border-radius: 12px;
  overflow: hidden;
}

.table {
  width: 100%;
  table-layout: auto; /* Untuk menyesuaikan lebar kolom */
}

/* Styling agar elemen dalam tabel tidak terpotong di perangkat mobile */
@media (max-width: 768px) {
  .table th,
  .table td {
    padding: 8px 4px; /* Mengurangi padding agar kolom lebih rapat */
    font-size: 12px; /* Menyesuaikan ukuran font di mobile */
  }

  .product-sub-title {
    font-size: 1rem; /* Ukuran font judul lebih kecil di mobile */
  }

  .product-sub-title-thin {
    font-size: 0.875rem; /* Ukuran font lebih kecil */
  }

  .text-installment {
    font-size: 0.85rem;
    text-align: center;
  }
}

.mobile-img {
  width: auto;
  max-width: 90%; /* Menjaga gambar agar tidak melebar */
  height: auto;
  max-height: 250px;
  object-fit: contain;
}
}

.table-wrapper-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-wrapper-scroll table {
  width: 1000px; /* atau auto jika kolom dinamis */
  min-width: 600px; /* pastikan tidak terlalu kecil */
}
</style>



// WEBPACK FOOTER //
// src/public/detail-produk-lending.vue